import {MenuProps} from "antd";
import {GiInnerSelf} from "react-icons/gi";
import {SiAbbott, SiCrehana, SiWebmoney} from "react-icons/si";
import React from "react";

const itemsIA: MenuProps['items'] = [
    {
        label: 'Sol·lucionat amb companys/es',
        key: '5',
        icon: <GiInnerSelf/>,
    },
    {
        label: 'Sol·lucionat amb IA (conversa)',
        key: '6',
        icon: <SiWebmoney/>,
    },
    {
        label: 'Sol·lucionat amb professor/a',
        key: '7',
        icon: <SiAbbott/>,
    },
    {
        label: 'Sortir de cua per altres motius',
        key: '8',
        icon: <SiCrehana/>,
    }
];

export default itemsIA;